/**
 * @description: 采购汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sr-cgh-report">
        <div class="ch-list">
            <p class="p-hint">注：进货价合计已扣除退款金额</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ch_time">
                        <input type="text" class="form-control laydate-icon" v-model="ch_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="ch_end_time">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ch_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ch_stock" data-placeholder="请选择仓库">
                    </select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ch_goods_type"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">供应商:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ch_supplier" data-placeholder="请选择供应商"></select>
                </div>
                <label class="list-label-4">采购类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ch_type">
                        <option value="0">全部</option>
                        <option value="1">采购</option>
                        <option value="2">赠送</option>
                        <option value="3">盈余</option>
                        <option value="4">换货</option>
                        <option value="-1">退货</option>
                        <option value="5">客遗</option>
                    </select>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="ch_goods_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-7">采购进货总数量:</label>
                <div class="list-total" ref="ch_in_total"></div>
                <label class="list-label-7">采购退货总数量:</label>
                <div class="list-total" ref="ch_out_total"></div>
                <label class="list-label-5">进货价合计:</label>
                <div class="list-total" ref="ch_amount"></div>
            </div>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="ch-merc btn btn-flat btn-border-gray btn-orange" @click="chListType(1)">按商品统计</button>
                    <button type="button" class="ch-sup btn btn-flat btn-border-gray" @click="chListType(2)">按供应商统计</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getChExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="initChTable">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ch_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="chExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix" v-show="ch_stat_type=='1'">
                        <li>
                            <input type='checkbox' v-model='chExport_allcheck1' @click='chExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="type_name">
                            <label>类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="supplier_name">
                            <label>供应商</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="quantity">
                            <label>进货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="refund_quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="amount">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="contract_amount">
                            <label>合同价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel1' value="amount_total">
                            <label>进货价合计</label>
                        </li>
                    </ul>
                    <ul class="set-area clearfix" v-show="ch_stat_type=='2'">
                        <li>
                            <input type='checkbox' v-model='chExport_allcheck2' @click='chExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="type_name">
                            <label>类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="supplier_name">
                            <label>供应商</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="quantity">
                            <label>进货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="refund_quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='chExport_checkModel2' value="amount_total">
                            <label>进货价合计</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix" v-show="ch_stat_type=='1'">
                        <li>
                            <input type="radio" v-model='chExport_type1' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='chExport_type1' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                    <ul class="clearfix" v-show="ch_stat_type=='2'">
                        <li>
                            <input type="radio" v-model='chExport_type2' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='chExport_type2' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ch_start_time: "",
                ch_end_time: "",
                ch_goods_name: "",
                ch_order: 'log._goods_type DESC',
                ch_group_by: '',
                ch_stat_type: '1',
                chExport_allcheck1: false,
                c_chExport_allcheck1: false,
                chExport_allcheck2: false,
                c_chExport_allcheck2: false,
                chExport_checkModel1: [],
                chExport_checkModel2: [],
                chExport_checkData1: [ 'store_name', 'type_name', 'supplier_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'refund_quantity', 'amount', 'contract_amount', 'amount_total'],
                chExport_checkData2: ['shop_name', 'store_name', 'type_name', 'supplier_name', 'quantity', 'refund_quantity', 'amount_total'],
                chExport_type1: 1,
                chExport_type2: 1,
            }
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.supplier_id) {
                        this.limitSearch()
                    }
                },
                deep: true
            },
            chExport_checkModel1: {
                handler: function (val, oldVal) {
                    if(this.chExport_checkModel1.length >= this.chExport_checkData1.length) {
                        this.chExport_allcheck1 = true;
                        this.c_chExport_allcheck1 = true;
                    } else {
                        this.chExport_allcheck1 = false;
                        this.c_chExport_allcheck1 = false;
                    }
                },
                deep: true
            },
            chExport_checkModel2: {
                handler: function (val, oldVal) {
                    if(this.chExport_checkModel2.length >= this.chExport_checkData2.length) {
                        this.chExport_allcheck2 = true;
                        this.c_chExport_allcheck2 = true;
                    } else {
                        this.chExport_allcheck2 = false;
                        this.c_chExport_allcheck2 = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ch_start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ch_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.getGoodsType(); // 商品类型
            this.getSupplier(); // 供应商
            this.innitInput();  // 门店
            $(this.$refs.ch_type).select2({
                minimumResultsForSearch: -1,
                width: '100%'
            });
        },
        methods: {
            // 跳转赋值
            limitSearch() {
                this.ch_start_time = moment().subtract(30, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                this.ch_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                $(this.$refs.ch_supplier).val(this.$route.params.supplier_id).trigger('change');
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.ch_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    }
                }, function(start, end, label) {
                    _this.ch_start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.ch_end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.ch_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.ch_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.ch_stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.ch_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.ch_stock).prop("disabled", false);
                            $(_this.$refs.ch_stock).val('').trigger('change');
                            _this.getstockdata(data.response.result[1].id);
                            if(_this.$route.params.supplier_id) {
                                _this.limitSearch()
                            }
                            _this.initChTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.ch_stock).html("");
                $(this.$refs.ch_stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ch_goods_type).html("");
                            $(_this.$refs.ch_goods_type).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取供应商
            getSupplier: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getSupplier",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: '0', text: '全部'}];
                            $.each(data.response.result.data.rows, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ch_supplier).html("");
                            $(_this.$refs.ch_supplier).select2({
                                data: arr,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 表格
            initChTable: function() {
                let _this = this;
                $(_this.$refs.ch_list).bootstrapTable('destroy');
                $(_this.$refs.ch_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getChList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "type_name",
                        title: "类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "supplier_name",
                        title: "供应商",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "进货数量",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "refund_quantity",
                        title: "退货数量",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "amount",
                        title: "进货单价",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "contract_amount",
                        title: "合同价",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "amount_total",
                        title: "进货价合计",
                        width: "8%",
                        valign: "middle"
                    }],
                });
                if(_this.ch_group_by != '') {
                    $(_this.$refs.ch_list).bootstrapTable('hideColumn', 'goods_type_name');
                    $(_this.$refs.ch_list).bootstrapTable('hideColumn', 'goods_name');
                    $(_this.$refs.ch_list).bootstrapTable('hideColumn', 'goods_unit_name');
                    $(_this.$refs.ch_list).bootstrapTable('hideColumn', 'amount');
                    $(_this.$refs.ch_list).bootstrapTable('hideColumn', 'contract_amount');
                }
            },
            getChList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ch_start_time,
                            "end_time": _this.ch_end_time,
                            "shop_id": $(_this.$refs.ch_shop).val(),
                            "store_id": $.trim($(_this.$refs.ch_stock).val()),
                            "goods_type": $.trim($(_this.$refs.ch_goods_type).val()),
                            "supplier_id": $(_this.$refs.ch_supplier).val(),
                            "type": $(_this.$refs.ch_type).val(),
                            "goods_name": _this.ch_goods_name,
                            "order": _this.ch_order,
                            "group_by": _this.ch_group_by
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPurchaseSummary",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.ch_in_total).text(data.response.result.quantity_total);
                            $(_this.$refs.ch_out_total).text(data.response.result.refund_quantity_total);
                            $(_this.$refs.ch_amount).text(data.response.result.amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 统计方式
            chListType: function(num) {
                this.ch_stat_type = num;
                if(num == '1') {
                    $('.ch-merc').addClass('btn-orange');
                    $('.ch-sup').removeClass('btn-orange');
                    this.ch_order = 'log._goods_type DESC';
                    this.ch_group_by = '';
                } else if(num == '2') {
                    $('.ch-merc').removeClass('btn-orange');
                    $('.ch-sup').addClass('btn-orange');
                    this.ch_order = '';
                    this.ch_group_by = 'log._store_id,log._relation_type,log._supplier_id';
                }
                this.initChTable();
            },
            // 获取导出设置
            getChExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/purchaseSummaryExport?type=" + _this.ch_stat_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                if(_this.ch_stat_type == '1') {
                                    _this.chExport_checkModel1 = data.response.result.export_fields;
                                    _this.chExport_type1 = data.response.result.export_type;
                                } else if(_this.ch_stat_type == '2') {
                                    _this.chExport_checkModel2 = data.response.result.export_fields;
                                    _this.chExport_type2 = data.response.result.export_type;
                                }
                            } else {
                                if(_this.ch_stat_type == '1') {
                                    _this.chExport_checkModel1 = _this.chExport_checkData1;
                                    _this.chExport_type1 = 1;
                                } else if(_this.ch_stat_type == '2') {
                                    _this.chExport_checkModel2 = _this.chExport_checkData2;
                                    _this.chExport_type2 = 1;
                                }
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.chExport_alert)
                }, function() {
                    _this.exportChList();
                });
            },
            // 导出字段全选
            chExportCheckedAll: function() {
                let _this = this;

                if(_this.ch_stat_type == '1') {
                    _this.chExport_allcheck1 = _this.c_chExport_allcheck1;
                    if(!_this.chExport_allcheck1) { // 实现全选
                        _this.chExport_checkModel1 = [];
                        _this.chExport_checkData1.forEach(function(item) {
                            _this.chExport_checkModel1.push(item);
                        });
                    } else { // 实现反选
                        _this.chExport_checkModel1 = [];
                    }
                } else if(_this.ch_stat_type == '2') {
                    _this.chExport_allcheck2 = _this.c_chExport_allcheck2;
                    if(!_this.chExport_allcheck2) { // 实现全选
                        _this.chExport_checkModel2 = [];
                        _this.chExport_checkData2.forEach(function(item) {
                            _this.chExport_checkModel2.push(item);
                        });
                    } else { // 实现反选
                        _this.chExport_checkModel2 = [];
                    }
                }
            },
            // 点击“导出”按钮
            exportChList: function() {
                let _this = this;

                if(_this.ch_stat_type == '1') {
                    let export_fields = JSON.stringify(_this.chExport_checkModel1);
                    window.location.href = Vue.ctUrl + "FinanceReport2/purchaseSummaryExport" +
                        "?start_time=" + _this.ch_start_time +
                        "&end_time=" + _this.ch_end_time +
                        "&shop_id=" + $(_this.$refs.ch_shop).val() +
                        "&store_id=" + $.trim($(_this.$refs.ch_stock).val()) +
                        "&goods_type=" + $.trim($(_this.$refs.ch_goods_type).val()) +
                        "&supplier_id=" + $(_this.$refs.ch_supplier).val() +
                        "&type=" + $(_this.$refs.ch_type).val() +
                        "&goods_name=" + _this.ch_goods_name +
                        "&order=" + _this.ch_order +
                        "&group_by=" + _this.ch_group_by +
                        "&stat_type=" + _this.ch_stat_type +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.chExport_type1;
                } else if(_this.ch_stat_type == '2') {
                    let export_fields = JSON.stringify(_this.chExport_checkModel2);
                    window.location.href = Vue.ctUrl + "FinanceReport2/purchaseSummaryExport" +
                        "?start_time=" + _this.ch_start_time +
                        "&end_time=" + _this.ch_end_time +
                        "&shop_id=" + $(_this.$refs.ch_shop).val() +
                        "&store_id=" + $.trim($(_this.$refs.ch_stock).val()) +
                        "&goods_type=" + $.trim($(_this.$refs.ch_goods_type).val()) +
                        "&supplier_id=" + $(_this.$refs.ch_supplier).val() +
                        "&type=" + $(_this.$refs.ch_type).val() +
                        "&goods_name=" + _this.ch_goods_name +
                        "&order=" + _this.ch_order +
                        "&group_by=" + _this.ch_group_by +
                        "&stat_type=" + _this.ch_stat_type +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.chExport_type2;
                }
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .ch-list {
        .pull-right {
            button {
                margin-left: 10px;
            }
        }
        table {
            word-wrap: break-word;
        }
    }
</style>